import { gql } from "@apollo/client";

export const MODIFICATE_RI = gql`
    mutation ModificacionRI(
        $input: ValidateRIInput!)
    {
        modificacionRI(input: $input)
    }
`;